export default {
    computed: {
        isActive() {
            const currentRoute = this.$route;
            const intendedRoute = this.route;

            return (
                currentRoute.name === intendedRoute.name &&
                Object.keys(intendedRoute.params).every(
                    key => String(intendedRoute.params[key]) === String(currentRoute.params[key])
                )
            );
        },
    },
};
